import { UsersTable } from "./components/table";

export const UsersView = () => <UsersTable />;
